export const REDUX_SHOW_SAMPLE_READ_ONLY_POPUP = 'REDUX_SHOW_SAMPLE_READ_ONLY_POPUP'
export const REDUX_HIDE_SAMPLE_READ_ONLY_POPUP = 'REDUX_HIDE_SAMPLE_READ_ONLY_POPUP'
export const REDUX_SHOW_SAMPLE_GENERATION_LIMIT_POPUP = 'REDUX_SHOW_SAMPLE_GENERATION_LIMIT_POPUP'
export const REDUX_HIDE_SAMPLE_GENERATION_LIMIT_POPUP = 'REDUX_HIDE_SAMPLE_GENERATION_LIMIT_POPUP'
